import { HubNewsTagCategoryItem, HubNewsTagItem, HubNewsTagSelection } from '@/types/hubs';

export const getPanelVisibleTags = (
    category: HubNewsTagCategoryItem,
    selection: HubNewsTagSelection,
    hasTaggedNews: boolean,
): HubNewsTagItem[] => {
    const selectedTagCds = selection[category.cd] ?? [];
    return category.tags.filter((tag) => hasTaggedNews || selectedTagCds.includes(tag.cd));
};
